import { Component, OnInit, Input } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'semso-pdf-viewer',
    templateUrl: './semso-pdf-viewer.component.html',
    styleUrls: ['./semso-pdf-viewer.component.scss']
})
export class SemsoPdfViewerComponent implements OnInit {

    @Input('source') source = '';
    @Input('page') page = 1;

    totalPages;
    isLoaded = false;

    ngOnInit(): void {}

    afterLoadComplete(pdfData: any) {
        this.totalPages = pdfData.numPages;
        this.isLoaded = true;
    }

    nextPage() {
      this.page++;      
    }

    prevPage() {
        this.page--;
    }
}



// WEBPACK FOOTER //
// ./src/app/semso-pdf-viewer/semso-pdf-viewer.component.ts